//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/edit/loadscreenview", vo, successCallback, failureCallback);
    },
    save: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bbs/edit/save", vo, successCallback, failureCallback);
    }
};

export default EditService;